module.exports = __webpack_public_path__ + "55389f0d8192f3f11c5deffefe89b565.svg";